<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'user']" /></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>アカウント設定</v-list-tile-title>
    </v-list-tile-content>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">アカウント設定</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field required
                    v-model="form.userid"
                    label="ログインID"
                    :rules="rules.userid"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch v-model="form.require" label="パスワードを変更する" color="blue darken-2" />
                </v-flex>
                <v-flex xs12 v-if="isPasswordRequired">
                  <v-text-field v-model="form.passwd1" required
                    name="password"
                    label="新しいパスワード"
                    type="password"
                    :rules="rules.passwd1"></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="isPasswordRequired">
                  <v-text-field v-model="form.passwd2" required
                    label="新しいパスワード（確認）"
                    type="password"
                    :rules="rules.passwd2"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p class="caption red--text text-xs-left" v-if="config.errors.auth">
                    <span>{{ config.errors.auth }}</span>
                  </p>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-btn depressed
            color="blue darken-2 white--text"
            :loading="isLoading"
            :disabled="!isValid"
            @click="submit">更新する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'tookitAccout',
  data () {
    return {
      config: {
        status: {
          active: false
        },
        errors: {
          auth: ''
        }
      },
      form: {
        valid: true,
        require: false,
        userid: '',
        passwd1: '',
        passwd2: ''
      },
      rules: {
        passwd1: [
          v => !!v || '必須項目です',
          v => v.length > 7 || '最低8文字は必要です'
        ],
        passwd2: [
          v => !!v || '必須項目です',
          v => v === this.form.passwd1 || 'パスワードが一致しません'
        ],
        userid: [
          v => !!v || '必須項目です',
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || '妥当なEメールではありません'
          }
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        require: false,
        userid: this.$localStorage.get('userid'),
        passwd1: '',
        passwd2: ''
      })
      this.$set(this.config.errors, 'auth', '')
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$set(this.config.errors, 'auth', '')
        if (this.form.require) {
          this.updateAuthAll()
        } else {
          this.updateAuthUserid()
        }
      }
    },
    updateAuthUserid: function () {
      this.axios.post(`${this.$url.api}user/auth/update/userid`, {
        userid: this.form.userid
      }, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
        this.$set(this.config.status, 'loading', false)
        if (res.data.success) {
          this.$localStorage.set('userid', this.form.userid)
          this.close()
        }
      })
    },
    updateAuthAll: function () {
      if (this.form.passwd1 === this.form.passwd2) {
        this.axios.post(`${this.$url.api}user/auth/test`, {
          passwd: this.form.passwd1
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data.success) {
            if (!res.data.data) {
              this.axios.post(`${this.$url.api}user/auth/update/all`, {
                userid: this.form.userid,
                passwd: this.form.passwd1
              }, {
                headers: {
                  'user-token': this.$localStorage.get('jwt')
                }
              }).then(res => {
                console.log(res)
                this.$set(this.config.status, 'loading', false)
                if (res.data.success) {
                  this.$localStorage.set('userid', this.form.userid)
                  this.close()
                }
              })
            } else {
              this.$set(this.config.errors, 'auth', '現在のパスワードと同じです')
              this.$set(this.config.status, 'loading', false)
            }
          } else {
            this.$set(this.config.status, 'loading', false)
          }
        })
      } else {
        this.$set(this.config.status, 'loading', false)
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isPasswordRequired () {
      return this.form.require
    }
  }
}
</script>
